/* eslint-disable */
import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";

import Toaster from "../Toaster/Toaster";

import { Button, Row, Col, Container, Table, Form } from "react-bootstrap";

import CreateMenu from "../CreateMenu";

function Escalations() {
  let params = useParams();
  let navigate = useNavigate();

  const [saved, setSaved] = useState(true);
  const [error, setError] = useState("");
  const [toast, setToast] = useState(); // es-lint-disable no-unused-vars
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false); // es-lint-disable no-unused-vars

  const [icEPs, seticEPs] = useState([]);
  const [leaderEPs, setLeaderEPs] = useState([]);

  const clearError = () => {
    setError("");
  };

  const createOption = (label) => ({
    label: label,
    // value: label.replace(/\W/g, ""),
    value: label,
  });

  const createOptionWithValue = (label, value) => ({
    label: label,
    value: value,
  });

  const fetchEscalationPolicies = (query) => {
    return fetch(`/api/v1/library/escalationpolicies?query=${query}`)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        throw new Error("not ok");
      })
      .catch((error) => {
        console.log(error);
      })
      .then((response) => {
        return response;
      });
  };

  const loadPolicies = (prefix) => {
    const enhancedPolicies = fetchEscalationPolicies(prefix).then((data) => {
      const policies = data.policies.map((p) => {
        const members = p.escalation_rules[0].targets.map((t) => {
          return { name: t.summary, id: t.id };
        });

        return { id: p.id, name: p.name, members: members };
      });

      return policies;
    });

    return enhancedPolicies;
  };

  useEffect(() => {
    setLoaded(false);

    fetchEscalationPolicies("EOC Leader").then((data) => {
      const icOptions = data.policies.map((p) => {
        const members = p.escalation_rules[0].targets.map((t) => {
          return { name: t.summary, id: t.id };
        });

        return {
          id: p.id,
          name: p.name,
          members: members,
        };
      });

      setLoaded(true);
    });
  }, []);

  return (
    <Container>
      <Toaster
        saved={saved}
        error={error}
        clearError={clearError}
        saving={saving}
        loaded={true}
        connected={true}
        message={toast}
      />
      <Row>
        <Col>
          <h3>Leadership Escalation Policies</h3>
        </Col>
      </Row>
      <Row>
        <Col>{icEPs}</Col>
      </Row>
    </Container>
  );
}

export default Escalations;
